import React from "react";
import DeviceShowcase from "../DeviceShowcase";

export default function POMockup() {
  const desktopUI = (
    <div className="w-full h-full flex flex-col text-sm bg-white">
      <div className="bg-slate-50 border-b border-slate-200 p-2 md:p-3 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <span className="font-semibold text-slate-700 text-xs md:text-sm">
            Lệnh Sản Xuất (PO): #PO-2605-089
          </span>
          <span className="px-2 py-0.5 bg-slate-200 text-slate-600 rounded text-[9px] md:text-[10px] font-mono">
            BOM Đa cấp
          </span>
        </div>
        <button className="px-3 py-1 bg-indigo-600 text-white rounded text-[10px] md:text-xs font-medium">
          Phát hành Lệnh
        </button>
      </div>
      <div className="p-3 md:p-4 flex-1 overflow-auto">
        <div className="flex gap-4 p-3 bg-slate-50 border border-slate-200 rounded-lg mb-4">
          <div className="w-16 h-16 bg-white border border-slate-200 rounded flex items-center justify-center overflow-hidden">
            <div className="w-12 h-12 bg-indigo-100 flex items-center justify-center text-indigo-400 text-xs font-bold rotate-12">
              HỘP
            </div>
          </div>
          <div className="flex-1 flex flex-col justify-center">
            <div className="font-bold text-slate-800 text-sm md:text-base">
              Hộp Giấy Mỹ Phẩm Tinh Chất Trắng Da
            </div>
            <div className="text-[10px] md:text-xs text-slate-500 mt-1">
              SL: 50,000 hộp | Khách hàng: Dược Phẩm Á Âu | Hạn giao: 15/06/2026
            </div>
          </div>
        </div>

        <div className="relative">
          <div className="absolute left-3.5 top-2 bottom-6 w-px bg-slate-200"></div>

          {/* Cấp 1: Thân hộp */}
          <div className="relative pl-8 mb-4">
            <div className="absolute left-2.5 top-1.5 w-2 h-2 rounded-full bg-slate-400 ring-4 ring-white"></div>
            <div className="bg-white border border-slate-200 rounded-md p-2 md:p-3 shadow-sm hover:border-indigo-300 transition-colors">
              <div className="flex justify-between items-center mb-2">
                <span className="font-bold text-slate-700 text-xs md:text-sm">
                  1. Thân Hộp (Ivory 350gsm)
                </span>
                <span className="text-[10px] text-indigo-600 font-medium bg-indigo-50 px-2 py-0.5 rounded">
                  SL Định mức: 50,500
                </span>
              </div>
              <div className="flex gap-1 mb-2">
                <span className="px-1.5 py-0.5 bg-slate-100 text-slate-600 text-[9px] rounded">
                  In Offset 4 màu
                </span>
                <span className="px-1.5 py-0.5 bg-slate-100 text-slate-600 text-[9px] rounded">
                  Cán mờ 1 mặt
                </span>
                <span className="px-1.5 py-0.5 bg-amber-100 text-amber-700 text-[9px] rounded">
                  Ép kim Logo
                </span>
              </div>
              <div className="text-[10px] text-slate-500 bg-slate-50 p-1.5 rounded">
                Vật tư xuất kho: 10,100 Tờ Ivory 350gsm (Khổ 79x109) - Bình 5
                hộp/tờ.
              </div>
            </div>
          </div>

          {/* Cấp 2: Khay lót */}
          <div className="relative pl-8">
            <div className="absolute left-2.5 top-1.5 w-2 h-2 rounded-full bg-slate-400 ring-4 ring-white"></div>
            <div className="bg-white border border-slate-200 rounded-md p-2 md:p-3 shadow-sm hover:border-indigo-300 transition-colors">
              <div className="flex justify-between items-center mb-2">
                <span className="font-bold text-slate-700 text-xs md:text-sm">
                  2. Khay lót giấy (Duplex 250gsm)
                </span>
                <span className="text-[10px] text-indigo-600 font-medium bg-indigo-50 px-2 py-0.5 rounded">
                  SL Định mức: 51,000
                </span>
              </div>
              <div className="flex gap-1 mb-2">
                <span className="px-1.5 py-0.5 bg-slate-100 text-slate-600 text-[9px] rounded">
                  Bế định hình
                </span>
              </div>
              <div className="text-[10px] text-slate-500 bg-slate-50 p-1.5 rounded">
                Vật tư xuất kho: 2,550 Tờ Duplex 250gsm (Khổ 65x86) - Bình 20
                khay/tờ.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const mobileUI = (
    <div className="w-full h-full flex flex-col bg-slate-50">
      {/* Lock screen / notification style */}
      <div className="w-full h-full p-3 pt-6 bg-[url('https://images.unsplash.com/photo-1557683316-973673baf926?q=80&w=300&auto=format&fit=crop')] bg-cover bg-center relative">
        <div className="absolute inset-0 bg-slate-900/60 backdrop-blur-sm"></div>

        <div className="relative z-10 flex flex-col h-full">
          <div className="text-center text-white/90 mb-8">
            <div className="text-[10px] font-medium">Thứ Hai, 25 Tháng 5</div>
            <div className="text-3xl font-light tracking-wider">09:41</div>
          </div>

          <div className="space-y-2 mt-4">
            {/* Notification Bubble */}
            <div className="bg-white/90 backdrop-blur-md rounded-xl p-3 shadow-lg transform transition-all duration-300 hover:scale-[1.02]">
              <div className="flex items-center gap-2 mb-1">
                <div className="w-4 h-4 rounded bg-indigo-600 flex items-center justify-center text-white text-[8px] font-bold">
                  EMS
                </div>
                <span className="text-[9px] text-slate-500 font-medium uppercase tracking-wider">
                  Lệnh SX Mới
                </span>
                <span className="text-[9px] text-slate-400 ml-auto">
                  Bây giờ
                </span>
              </div>
              <div className="text-xs font-bold text-slate-800 leading-tight mb-1">
                PO-2605-089: Hộp Mỹ Phẩm Tinh Chất
              </div>
              <div className="text-[10px] text-slate-600 leading-snug">
                Lệnh in Offset (10,100 tờ) đã được phát hành xuống xưởng. Nhấn
                để xem chi tiết bình bài.
              </div>
            </div>

            {/* Another Notification Bubble */}
            <div className="bg-white/70 backdrop-blur-md rounded-xl p-3 shadow-lg">
              <div className="flex items-center gap-2 mb-1">
                <div className="w-4 h-4 rounded bg-emerald-600 flex items-center justify-center text-white text-[8px] font-bold">
                  EMS
                </div>
                <span className="text-[9px] text-slate-500 font-medium uppercase tracking-wider">
                  Lịch Xuất Kho
                </span>
                <span className="text-[9px] text-slate-400 ml-auto">
                  5p trước
                </span>
              </div>
              <div className="text-xs font-bold text-slate-800 leading-tight mb-1">
                Yêu cầu chuẩn bị 3 Pallet Ivory
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  return <DeviceShowcase desktopUI={desktopUI} mobileUI={mobileUI} />;
}
